export default __webpack_public_path__ + "assets/images/solutions/3893fc3d7c14ded1e8ca9b38664f8a78.mp4";